import React, { useCallback, useRef, useState } from 'react';
import config from './config.json';
import { modalAddOrEditFn } from './components/addOrEdit';
import { message} from 'antd';
import { SActionBtn, SLowcodeList, STableActions } from 'shj-components'
import { chargebackRelationshipList, chargebackRelationshipEnabled, chargebackRelationshipDisabled, chargebackRelationshipDelete } from '@/services/fmsConfig'
import { httpDictServTenant } from '@/services/fmsServices'
export default function () {
  const listRef = useRef<any>();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await chargebackRelationshipList(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise(async(resolve, reject) => {
      const refundTypeList:any = await httpDictServTenant({ parentKey: 'refundType', enabled: 1 })//退款类型 //
      resolve({
        refundTypeList,
      });
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  // 新增
  const add = (obj = {}) => {
    const {
      current: { reload },
    } = listRef;
    modalAddOrEditFn({
      fn: () => {
        reload();
      },
      ...obj,
    });
  };
  const onEdit = (obj: any) => {
    add(obj);
  };

  const onAdd = () => {
    add();
  };

  const onLook = (obj: any) => {
    add(obj);
  }

  const onDel = (record) => {
    chargebackRelationshipDelete(record.id).then((response: any) => {
        message.success(response?.message || '删除成功');
        reloadFn();
      });
  }

  const onEnabled = (record) => {
    chargebackRelationshipEnabled(record.id).then((response: any) => {
      message.success(response?.message || '操作成功');
      reloadFn();
    });
  }

  const onDisabled = (record) => {
    chargebackRelationshipDisabled(record.id).then((response: any) => {
      message.success(response?.message || '操作成功');
      reloadFn();
    }); 
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    // status: {
    //   btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    // },
    customRender: {
      // refundableTypeText(text:any) {
      //   return text === 0 ? '按收款金额' : '按收款未核销金额'
      // },
      // 渲染操作栏
      renderOperate(text:any, record: any) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                编辑
              </SActionBtn>
              <SActionBtn onClick={() => onLook({...record, isLook:true})}>
                查看
              </SActionBtn>
              {
                record.billStatus === 'enable' ? <SActionBtn onClick={() => onDisabled(record)}>
                禁用
              </SActionBtn> : <SActionBtn onClick={() => onEnabled(record)}>
                启用
              </SActionBtn>
              }
              {/* <SActionBtn tipText='是否删除？' title="是否删除？" danger confirm
                onClick={() => onDel(record)} okText="是" cancelText="否" >
                  删除
              </SActionBtn>   */}
            </STableActions>
          </div>
        );
      },
    },
  };

  return <><SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" /></>
}
